<template>
    <div>
          <div class="pop_search_bg bgf7 w900" >
            <div class="input-group-02">
              <div class="colum-02 col-4">
                <div class="form_box-02">
                  <label for="code">차량번호</label>
                  <input type="text" id="code" class="input-text" placeholder="" value="" autocomplete="off"
                        v-model.lazy.trim="value.carId">
                </div>
              </div>
              <div class="colum-02 col-1">
                <div class="form_group">
                  <a href="javascript:void(0);" v-on:click="carLpnSearch" class="account_btn" >조회</a>
                </div>
              </div>
            </div>
          </div>
          <!-- 검색 결과 부분 -->
          <div class="product_sh_result">
            <div class="sub_left_wrap">
              <span>{{this.carName}}</span>   
            </div>
            <div class="sub_right_wrap">
              <div class="btn_area pt0">
                <a href="javascript:void(0);" class="button white" v-on:click="openCarModelViewPopup"><span class="fz13">차량모델 보기</span></a>
              </div>
            </div>
          </div>
          <carModelViewPopup v-model="carModelCode"/>
    </div>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import CarModelViewPopup from '../../common/CarModelViewPopup.vue'

export default {
    name : 'tabCarLpn',
    components : { Grid, GridModule, Vue, CarModelViewPopup },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            //pushToParent: '', //자식이 부모창으로 전달
            carModel : [],
            carInfoByLpn : [],
            carName : '',
            carModelCode : '',
            grid_options : {
                general : {
                  id  : '',  //차량번호를 통해 자동차종류 자동차이름 검색
                  search : '',
                  type : {
                      isUpdate : false,
                      //isHideAdd : true : true,
                  },
                  params : {
                      carId: ''
                  }              
                }
            }
        }
    },
    created() {
      this.carName = '';
    },
    mounted () {

    },
    methods : {
        carLpnSearch () {
          // Vue.httpClient
          // .get('/kuktobudb/차종이름결과', {params : { carId : this.value.carId }})
          // .then((result) => {
          //   if ( result.data.result ) {
          //     let list = result.data.result.list;
          //     for(var key in list) {
          //        this.carInfoByLpn = list.[key];
          //     }
          //     alert("조회된 자동차 모델명:::" + JSON.stringify(this.carInfoByLpn.carModelName));
          //   }
          // })
          //현재 차종 조회하는 컨트롤러가 없으므로.. 임의로 세팅
          this.carName = 'The 1970 Camaro SS 396'; //this.carInfoByLpn.carModelName

        },
        openCarModelViewPopup() {
          this.$modal.show('carModelViewPopup', {});
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/partsCodeSearch/TabCarLpn.vue